import React from 'react';

const BarraDeCarga = ({
  totalFragmentos,
  fragmentosCargados,
  colorCargado,
  porcentaje,
  estadoAvance,
  modoExtra = false,
  porcentajeExtra = 0
}) => {
  // --- MODO EXTRA ---
  if (modoExtra) {
    const clampedExtra = Math.min(Math.max(0, porcentajeExtra), 100);
    return (
      <div
        style={{
          marginTop: "1px",
          width: '40px',
          height: '13px',
          borderRadius: '4px',
          backgroundColor: 'gold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#333',
          fontWeight: 'bold',
          fontSize: '0.6rem',
          overflow: 'hidden'
        }}
      >
        +{clampedExtra}%
      </div>
    );
  }

  // --- MODO PORCENTAJE ---
  if (typeof porcentaje === 'number') {
    const clamped = Math.min(Math.max(0, porcentaje), 100);

    let color = 'red';
    if (clamped >= 100) color = 'green';
    else if (estadoAvance === 'bueno') color = 'blue';

    console.log('Estado Avance:', estadoAvance, 'Color:', color, 'Porcentaje:', clamped);

    return (
      <div
        style={{
          width: '100%',
          height: '13px',
          borderRadius: '4px',
          backgroundColor: '#e0e0e0',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            width: `${clamped}%`,
            height: '100%',
            backgroundColor: color,
            transition: 'width 0.3s ease, background-color 0.3s ease'
          }}
        />
      </div>
    );
  }

  // --- MODO FRAGMENTOS (default) ---
  const total = Math.max(1, totalFragmentos);
  const cargados = Math.min(Math.max(0, fragmentosCargados), total);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        gap: '4px'
      }}
    >
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          style={{
            flex: 1,
            height: '12px',
            borderRadius: '4px',
            backgroundColor: index < cargados ? colorCargado : '#e0e0e0',
            transition: 'background-color 0.3s ease'
          }}
        />
      ))}
    </div>
  );
};

export default BarraDeCarga;
